import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const CustomPopup = () => {
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    isOpen && (
      <Box
        sx={{
          position: "fixed",
          top: "20%",
          left: "50%",
          transform: "translate(-50%, -20%)",
          width: 1000,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
          zIndex: 1000,
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" sx={{ textAlign: "center", fontSize: "20px" }}>
            We have over 300 of the best fitters in the world inputting information from over 1 million customer swings a month into our AI.  On top of that I am here in person and will make my own recommendations based on our work together in the bay.  So you have the best of all worlds to get the most distance and accuracy to improve your game.  None of our fitting competitors have this, and even if they did they would not analyze anywhere close to 1 million swings a month, so the data would not be as statistically significant compared to what the AI Co-Pilot and I will deliver to you.
          </Typography>
          <IconButton size="small" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
    )
  );
};

export default CustomPopup;